import { approverPermission } from './standing-authority.js';
/**
 * Approval cards (Warren, 29 Oct 2026, item 2): one card per action, with what, who, how much and why, approved or
 * declined by a person in Admin, Today, Approvals. Approve runs the same audited path the scripts run. Only a person
 * approves: no agent, script or email link can.
 */
export const CARD_KINDS = [
    'topup_refund', 'session_refund', 'make_good_credit', 'below_minimum_waiver', 'ops_waiver', 'host_share_payment', 'data_repair', 'receipt_send',
];
export const CARD_STATUSES = ['pending', 'executing', 'done', 'failed', 'declined', 'expired', 'stale'];
/** The statuses a card can still be acted on in. */
export const LIVE_CARD_STATUSES = ['pending', 'executing'];
/** Which approver type each kind of card needs. */
export const CARD_APPROVER_TYPE = {
    topup_refund: 'driver_money', session_refund: 'driver_money', make_good_credit: 'driver_money', below_minimum_waiver: 'driver_money',
    ops_waiver: 'driver_money', host_share_payment: 'host_payment', data_repair: 'data', receipt_send: 'receipts',
};
export const cardPermission = (kind) => approverPermission(CARD_APPROVER_TYPE[kind]);
export const CARD_KIND_LABELS = {
    topup_refund: 'Wallet top-up refund', session_refund: 'Session refund', make_good_credit: 'Make-good credit',
    below_minimum_waiver: 'Below-minimum waiver', ops_waiver: 'Stranded session waiver', host_share_payment: 'Host share payment',
    data_repair: 'Data repair', receipt_send: 'Receipt',
};
export const CARD_STATUS_LABELS = {
    pending: 'Waiting', executing: 'Running', done: 'Done', failed: 'Failed', declined: 'Declined', expired: 'Expired', stale: 'Changed, replaced',
};
//# sourceMappingURL=approvals.js.map